import { styled } from '@vebox/etui-system';
import '../../../utilities/format-ms.js';
import '../../../utilities/create-transition.js';
import { useContext, createElement } from 'react';
import '../../../utilities/get-styleprop.js';
import { b as _extends, a as _objectSpread2 } from '../../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../../../Svg-0180d7b5.js';
import '../../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../../Icon/icons.js';
import '../../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../../ErrorLabel/ErrorLabel.js';
import '../../../FormItem/FormItem.js';
import '../../../Input/Input.js';
import '../../../InputLabel/InputLabel.js';
import '../../../ClickOutside/ClickOutside.js';
import '../../../Tooltip/Tooltip.js';
import '../../../Button/Button.js';
import 'lodash.isnil';
import { removeField } from '../../utils.js';
import '../../state/constants.js';
import { setValue, removeValue } from '../../state/actions.js';
import FilterPanelContext from '../../FilterPanelContext.js';
import ApplyFilterButton from '../ApplyFilterButton.js';
import NumberInput from '../../../NumberInput/NumberInput.js';

const RangeInputControlWrapper = styled(Div)`
  display: flex;
  flex: 1;
`;

const RangeDelimiter = styled(Div)`
  display: flex;
  align-items: center;
  margin: 0 ${({
  theme
}) => theme.spacing.xs}px;
  font-weight: ${({
  theme
}) => theme.typography.fontWeightBold};
`;

const RangeInputControl = ({
  field,
  label,
  showApplyButton,
  applyButtonLabel,
  minInputFieldProps,
  maxInputFieldProps
}) => {
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const savedRange = state.toBeAppliedFilters[field];
  return /*#__PURE__*/createElement(RangeInputControlWrapper, {
    id: field
  }, /*#__PURE__*/createElement(NumberInput, _extends({
    key: `${field}-min`
  }, minInputFieldProps, {
    value: savedRange === null || savedRange === void 0 ? void 0 : savedRange.min,
    label: label.min,
    onChange: value => {
      if (value) {
        dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedRange), {}, {
          min: value
        })));
        return;
      }
      if (!(savedRange !== null && savedRange !== void 0 && savedRange.max)) {
        dispatch(removeValue(field));
        return;
      }
      dispatch(setValue(field, removeField(savedRange, 'min')));
    }
  })), /*#__PURE__*/createElement(RangeDelimiter, null, "-"), /*#__PURE__*/createElement(NumberInput, _extends({
    key: `${field}-max`
  }, maxInputFieldProps, {
    value: savedRange === null || savedRange === void 0 ? void 0 : savedRange.max,
    label: label.max,
    onChange: value => {
      if (value) {
        dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedRange), {}, {
          max: value
        })));
        return;
      }
      if (!(savedRange !== null && savedRange !== void 0 && savedRange.min)) {
        dispatch(removeValue(field));
        return;
      }
      dispatch(setValue(field, removeField(savedRange, 'max')));
    }
  })), showApplyButton && /*#__PURE__*/createElement(ApplyFilterButton, {
    field: field,
    applyButtonLabel: applyButtonLabel
  }));
};

export default RangeInputControl;
